import React from 'react';
import PropTypes from 'prop-types';
import DropDownList from '../../../component/iconDropDown/iconDropDown';
import { PUSPAKOM_RESULT_OPTIONS } from './maintenanceComplianceFormUtils';

const MaintenanceComplianceEditModal = ({
  title,
  section,
  complianceForm,
  saveError,
  renewSuccess,
  saveLoading,
  renewMinDate,
  useRenewDateRules,
  selectedPuspakomResult,
  onClose,
  onSave,
  onFormChange,
}) => (
  <div className="maintenance-modal-overlay">
    <div
      className="maintenance-modal maintenance-compliance-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="maintenance-compliance-modal-title"
    >
      <div className="maintenance-modal-header">
        <h3 id="maintenance-compliance-modal-title" className="maintenance-modal-title">
          {title}
        </h3>
        <button
          type="button"
          className="maintenance-modal-close"
          aria-label="Close"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
      <div className="maintenance-modal-body">
        {section === 'roadTax' && (
          <div className="maintenance-form-grid">
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="roadTaxExpiry">Expiry date</label>
              <input
                id="roadTaxExpiry"
                type="date"
                className="maintenance-form-input"
                value={complianceForm.roadTaxExpiry}
                min={useRenewDateRules ? renewMinDate : undefined}
                onChange={(e) => onFormChange('roadTaxExpiry', e.target.value)}
              />
            </div>
          </div>
        )}
        {section === 'puspakom' && (
          <div className="maintenance-form-grid">
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="puspakomLastDate">Last inspection date</label>
              <input
                id="puspakomLastDate"
                type="date"
                className="maintenance-form-input"
                value={complianceForm.puspakomLastDate}
                onChange={(e) => onFormChange('puspakomLastDate', e.target.value)}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="puspakomNextDue">Next due date</label>
              <input
                id="puspakomNextDue"
                type="date"
                className="maintenance-form-input"
                value={complianceForm.puspakomNextDue}
                min={useRenewDateRules ? renewMinDate : undefined}
                onChange={(e) => onFormChange('puspakomNextDue', e.target.value)}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="puspakomResult">Result</label>
              <DropDownList
                placeholder="Select result"
                width="100%"
                menuPortal
                selectedValue={selectedPuspakomResult}
                setSelectedValue={(option) => onFormChange('puspakomResult', option?.value || '')}
                options={PUSPAKOM_RESULT_OPTIONS.map((item) => ({ label: item, value: item }))}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="puspakomCertNumber">Certificate number</label>
              <input
                id="puspakomCertNumber"
                type="text"
                className="maintenance-form-input"
                value={complianceForm.puspakomCertNumber}
                onChange={(e) => onFormChange('puspakomCertNumber', e.target.value)}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="puspakomCentre">Inspection centre</label>
              <input
                id="puspakomCentre"
                type="text"
                className="maintenance-form-input"
                value={complianceForm.puspakomCentre}
                onChange={(e) => onFormChange('puspakomCentre', e.target.value)}
              />
            </div>
          </div>
        )}
        {section === 'insurance' && (
          <div className="maintenance-form-grid">
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="insuranceProvider">Provider</label>
              <input
                id="insuranceProvider"
                type="text"
                className="maintenance-form-input"
                value={complianceForm.insuranceProvider}
                onChange={(e) => onFormChange('insuranceProvider', e.target.value)}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="insurancePolicyNumber">Policy number</label>
              <input
                id="insurancePolicyNumber"
                type="text"
                className="maintenance-form-input"
                value={complianceForm.insurancePolicyNumber}
                onChange={(e) => onFormChange('insurancePolicyNumber', e.target.value)}
              />
            </div>
            <div className="maintenance-form-group">
              <label className="maintenance-form-label" htmlFor="insuranceExpiry">Expiry date</label>
              <input
                id="insuranceExpiry"
                type="date"
                className="maintenance-form-input"
                value={complianceForm.insuranceExpiry}
                min={useRenewDateRules ? renewMinDate : undefined}
                onChange={(e) => onFormChange('insuranceExpiry', e.target.value)}
              />
            </div>
          </div>
        )}
        {renewSuccess && (
          <div className="maintenance-compliance-inline-success">{renewSuccess}</div>
        )}
        {saveError && <div className="maintenance-compliance-modal-message">{saveError}</div>}
      </div>
      <div className="maintenance-modal-footer">
        <button
          type="button"
          className="maintenance-modal-cancel"
          onClick={onClose}
          disabled={saveLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="maintenance-modal-submit"
          onClick={onSave}
          disabled={saveLoading}
        >
          {saveLoading ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  </div>
);

MaintenanceComplianceEditModal.propTypes = {
  title: PropTypes.string.isRequired,
  section: PropTypes.oneOf(['roadTax', 'puspakom', 'insurance']).isRequired,
  complianceForm: PropTypes.object.isRequired,
  saveError: PropTypes.string,
  renewSuccess: PropTypes.string,
  saveLoading: PropTypes.bool,
  renewMinDate: PropTypes.string,
  useRenewDateRules: PropTypes.bool,
  selectedPuspakomResult: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
};

MaintenanceComplianceEditModal.defaultProps = {
  saveError: '',
  renewSuccess: '',
  saveLoading: false,
  renewMinDate: '',
  useRenewDateRules: false,
  selectedPuspakomResult: null,
};

export default MaintenanceComplianceEditModal;
